<script lang="ts" setup>
import { onBeforeMount, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { DynamicForm } from '../../dynamic-form'
import { getForm } from '../../../core/services/forms'
import { getLoan } from '../../../core/services/loans'
import { useNotificationsStore } from '@/store/notifications'
import { usePayrollStore } from '@/store/payroll-data'
import { usePayrollChange } from '@/app/core/composable/routes/useChangePayroll'
import { getErrorCode } from '@/app/core/composable/general'
import { getSelectData } from '@/app/core/services/get-table'
import { DLoading } from 'front-library'
import { useI18n } from 'vue-i18n'
usePayrollChange(() => back())

/* payload, router, notifications */
const storePayroll = usePayrollStore()
const notifications = useNotificationsStore()
const router = useRouter()
const route = useRoute()
const customForm = ref<any>({})
const { t } = useI18n()

/* Datos componente Loading */
const loading = ref(false)

/* Datos */
let model: any = {}

const getEntity = async () => {
  loading.value = true
  try {
    if (!route.params.id) return
    model = await getLoan(route.params.id as string)
    if (model === undefined) {
      notifications.addNotification({
        title: t('notification.notFound'),
        text: t('loans.notification.error'),
        type: 'error',
        time: 10000
      })
      back()
    }
    loading.value = false
  } catch (error: any) {
    if (error.response.status === 400) {
      notifications.addNotification({
        title: t('notification.notFound'),
        text: t('loans.notification.error'),
        type: 'error',
        time: 10000
      })
      back()
    } else {
      loading.value = false
      const code = getErrorCode(error.response.data?.code)
      notifications.addNotification({
        title: t('error.titles.' + code),
        text: t('error.messages.' + code),
        type: 'error',
        time: 10000
      })
    }
  }
}

const onUpdateField = async (field: any) => {
  if (
    field.name === 'typeLoansId' &&
    storePayroll.payroll?.country.iso_code === 'MX'
  ) {
    loading.value = true
    const data = customForm.value.tabs.flatMap((tab: { groups: any[] }) =>
      tab.groups.flatMap(
        (group: { fields: any[] }) =>
          group.fields.find((input: { name: any }) => input.name === field.name)
            ?.query
      )
    )[0]
    const selectData: any[] = await getSelectData(data)
    const codeLoanType = selectData.find(
      (item: { id: any }) => item.id === field.value
    )?.code
    customForm.value.tabs.forEach((tab: { groups: any[] }) =>
      tab.groups.forEach((group: { fields: any[] }) =>
        group.fields.forEach((input: { name: string; label: string }) => {
          if (input.name === 'quotaAmount') {
            switch (codeLoanType) {
              case 'INFONAVIT-SM':
                input.label = t('loans.fields.infonavitSM.label')
                break
              case 'INFONAVIT-CF':
                input.label = t('loans.fields.infonavitCF.label')
                break
              case 'INFONAVIT-PF':
                input.label = t('loans.fields.infonavitPF.label')
                break
            }
          }
        })
      )
    )
    loading.value = false
  }
}

const back = () => {
  void router.push({ name: 'ListLoans' })
}

onBeforeMount(async () => {
  await getEntity()
  customForm.value = await getForm({ entity: 'loans' })
  onUpdateField({ name: 'typeLoansId', value: model.typeLoansId })
})
</script>
<template>
  <DLoading v-show="loading" :message="$t('loading.data')" />
  <div class="h-full px-5">
    <div class="bg-gray-50 pb-4">
      <div class="leading-4 pt-responsive">
        <p
          class="text-3xl font-semibold text-shadow text-blue-900"
          v-html="t('loans.get')" />
      </div>
    </div>
    <DynamicForm
      v-if="customForm?.tabs"
      :form-schema="customForm"
      :initial-model="model"
      :readonly="true"
      :get-data="true"
      @cancel="back" />
  </div>
</template>
